import React from 'react';
import * as mobxReact from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import { OEToggle } from '../../global/oe-toggle/oe-toggle';
import Text from '../../global/text/text';
import { DataAnonymizationFormVM } from './data-anonymization-form.viewmodel';
import { CommonPopupBodyFooterLayout } from '../../global/common-popup/common-popup-body-footer-layout';
import './data-anonymization-form.scss';
import { AUTOMATIC_DATA_ANONYMIZATION_STATUS_TEXT, DAYS_COUNT_BEFORE_ANONYMIZATION_TEXT, EVENT_DATA_WILL_BE_ANONYMIZED_TEXT } from '../account-admin.text';
import { AccountAdminSettingFormFooter } from '../common/account-admin-setting-form-footer';

interface IProps {
    vm: DataAnonymizationFormVM;
}

const DataAnonymizationFormPresentation = mobxReact.observer((props: IProps) => {
    const { vm } = props;
    const { settingsEntity } = vm;

    return (
        <CommonPopupBodyFooterLayout
            body={
                <>
                    <div className='oe-form data-anonymization-form'>
                        <div className='oe-form__body'>
                            <div className='m-top-10px m-bottom-0px flex center'>
                                <OEToggle
                                    isSelected={settingsEntity.enabled}
                                    onClick={settingsEntity.toggleEnabled}
                                />
                                <Text
                                    {...AUTOMATIC_DATA_ANONYMIZATION_STATUS_TEXT}
                                    values={{
                                        suffix: settingsEntity.suffix
                                    }}
                                    className='line-height-25px'
                                />
                            </div>
                            {settingsEntity.enabled && <div className='m-top-10px m-bottom-0px'>
                                <div>
                                    <FormattedMessage {...EVENT_DATA_WILL_BE_ANONYMIZED_TEXT} />
                                    <input
                                        placeholder='XX'
                                        type='number'
                                        value={settingsEntity.additionalData as number}
                                        className='oe-form-field__control m-left-4px m-right-4px'
                                        onChange={({ target: { value } }) => settingsEntity.setAdditionalData(+value )}
                                        style={{ display: 'inline' }}
                                    />
                                    <FormattedMessage {...DAYS_COUNT_BEFORE_ANONYMIZATION_TEXT} />
                                </div>
                                {vm.getDataAnonymizationEnabledValidationError() && <span className='oe-form-field__error'>{vm.getDataAnonymizationEnabledValidationError()}</span>}
                            </div>}
                        </div>
                    </div>
                </>
            }
            footer={
                <AccountAdminSettingFormFooter
                    handleClose={vm.handleClose}
                    handleSubmit={vm.handleSubmit}
                    isDisabled={!!vm.getDataAnonymizationEnabledValidationError()}
                />
            }
        />
    );
});

export { DataAnonymizationFormPresentation };
